/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'
import Placeholder from '../../../common/Placeholder'
import Loader from '../../../common/loader/legacy-loaders/Op36Loader-web'
import StudentPreviewCard from '../../../common/StudentPreviewCard'

const renderTemplateStudents = (loading, students, t) => {
  if (loading) { return <Loader message={t('profile.goals.templateStudents.loadingStudents')} /> }
  if (students && students.length > 0) {
    return students.map(student => (
      <StudentPreviewCard
        preview
        student={student}
        key={student.id}
      />
    ))
  }

  return (
    <div className='w-100'>
      <Placeholder
        title={t('profile.goals.templateStudents.noStudentsAssigned')}
        icon={'fa-users'}
        subtext1={t('profile.goals.templateStudents.noStudentsAssignedSubtext')}
        subtext2={t('profile.goals.templateStudents.addStudentsHint')}
      />
    </div>
  )
}

const TemplateStudentsCard = ({ toggleModal, loading, students }) => {
  const { t } = useTranslation()
  return (
    <div className='card mt-15px p-0 col-md-12'>
      <h5 className='p-2 card-header-text'>{t('profile.goals.templateStudents.students')}</h5>
      <div className='p-4'>
        <div className='row w-100 mx-auto'>
          {renderTemplateStudents(loading, students, t)}
        </div>
      </div>
      <div className='custom-goal-button-wrapper px-5'>
        <button
          className='btn btn-primary btn-block custom-goal-btn'
          onClick={toggleModal}
        >
          {t('profile.goals.templateStudents.addStudents')}
        </button>
      </div>
    </div>
  )
}

export default TemplateStudentsCard
